var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / Flavor / SKQ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "skq-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001246,7 C14.1671932,7 8.39281117,11.0797716 8.39281117,16.53317 C8.39281117,20.1648934 10.833615,22.4765563 14.1962602,22.4765563 C17.1241452,22.4765563 18.3756903,21.0900568 19.6999032,19.6221696 C21.0776826,18.0961481 22.5019692,16.517806 25.7263383,16.517806 C29.8895739,16.517806 32.3773002,19.764183 32.3773002,22.9025966 C32.3773002,23.3070441 32.3627667,23.7036021 32.3399283,24.0901942 C32.7659685,22.8037685 33.0001661,21.4297264 33.0001661,20.0000415 C33.0001661,12.8204741 27.1801073,7 20.0001246,7 M20.0001246,7.73124455 C26.6236804,7.73124455 32.0376307,13.0069186 32.2614472,19.576908 C31.113713,17.4321731 28.8427439,15.7865614 25.7263383,15.7865614 C22.1768332,15.7865614 20.5727459,17.5638054 19.1571794,19.1321817 C17.8396104,20.5917641 16.7994244,21.7448965 14.1962602,21.7448965 C11.1624881,21.7448965 9.12447096,19.6504061 9.12447096,16.53317 C9.12447096,14.1965924 10.3091619,11.9820966 12.4601254,10.297452 C14.5421584,8.66678911 17.290658,7.73124455 20.0001246,7.73124455 Z M31.4487317,22.9025135 C31.4487317,28.7420888 26.0592809,33 20.0000415,33 C12.8204741,33 7,27.1799412 7,19.9999585 C7,18.799073 7.16609757,17.6372205 7.47130185,16.533087 C7.61456101,20.5343774 10.397941,23.4049587 14.1965924,23.4049587 C17.5372298,23.4049587 18.9872616,21.7979647 20.3895403,20.2445371 C21.6880081,18.8053017 22.9146386,17.4466236 25.7262552,17.4466236 C29.3081493,17.4466236 31.4487317,20.2208682 31.4487317,22.9025135 Z",
    id: "skq-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skq-icon-/-Flavor-/-SKQ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "skq-Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "skq-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "skq-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "skq-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "skq-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#skq-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "skq-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#skq-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "skq-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#skq-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "skq-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#skq-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "skq-Combined-Shape",
    fill: "#231F20",
    xlinkHref: "#skq-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "skq-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#skq-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkq);
export default __webpack_public_path__ + "static/media/SKQ.1257dda94cc6f0cf91b1a6e4014563bc.svg";
export { ForwardRef as ReactComponent };